"use client";
import useUserProps from "@/hooks/user/useUserProps";
import { usePathname, useRouter } from "next/navigation";
import { startTransition, useEffect } from "react";
import { determineLoginRoute } from "@/modules/AccountTypeSection/login/helpers/routeHelpers";
import nProgress from "nprogress";
import { clearAllUserData } from "@/modules/AccountTypeSection/login/helpers/storageHelpers";
import useToolkit from "@/hooks/misc/useToolkit";
import OptionalView from "../misc/OptionalView";
import { turnOnNewUser } from "@/redux/slices/dashboardSlice";

export default function GlobalMiddleware() {
  const router = useRouter()
  const pathname = usePathname()
  const { dispatch } = useToolkit()
  const { isValidUser, user: response } = useUserProps()
  const isAuthRoute = pathname?.includes("auth/") || pathname === "/"

  const isStartingPersonalOnboarding = pathname === "/onboarding/personal"
  const isStartingBusinessOnboarding = pathname === "/onboarding/business"
  const userIsStartingOnboarding = isStartingPersonalOnboarding || isStartingBusinessOnboarding

  // useEffect(() => {
  //   if (isAuthRoute && isValidUser) {
  //     const destinationRoute = determineLoginRoute({ response });
  //     nProgress.start();
  //     startTransition(() => router.push(destinationRoute));
  //   }

  //   if (userIsStartingOnboarding && isValidUser) {
  //     if(!){
  //     dispatch(turnOnNewUser())
  //     clearAllUserData(dispatch)
  //     }

  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isAuthRoute, isValidUser, userIsStartingOnboarding])


  return (
    <div>
      <OptionalView condition={false}>
        <button onClick={() => clearAllUserData(dispatch)}>
          Click here
        </button>
      </OptionalView>

      <div />
    </div>
  );
}
